<template>
  <v-container class="page-content px-5" style="width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
    >
      <v-text-field
          single-line
          outlined
          dense
          clearable
          :disabled="isLoading"
          v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
      </v-text-field>
      <v-select
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="pagination.filters.order_type"
          label="Тип пропуска"
          class="pt-7 pr-1 pl-2"
          outlined
          dense
          style="padding-bottom: 2px"
          single-line
          flat
          clearable
          :disabled="isLoading"
          :items="choices.order_type"
      >
      </v-select>
      <v-select
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="pagination.filters.order_status"
          label="Статус заявки"
          class="pt-7 px-1"
          style="padding-bottom: 2px"
          single-line
          flat
          outlined
          dense
          clearable
          :disabled="isLoading"
          :items="choices.order_status"
      >
      </v-select>
      <v-spacer></v-spacer>
      <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          icon
          class="mr-0 dark-primary"
          @click="newOrder"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          icon
          class="mr-0 dark-primary"
          @click="generateFile"
      >
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn
          icon
          class="mr-0 dark-primary"
          @click="show = !show"
      >
        <v-icon>{{ show ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn
            text
            @click="newOrder"
            class="dark-primary"
        >
          Добавить заявку
        </v-btn>
        <v-btn
            class="dark-primary rounded-tr-lg"
            text
            @click="generateFile"
        >
          Скачать
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-slide-y-transition>
      <v-toolbar color="#DADADA" v-if="show" elevation="0" :height="extensionHeight">
        <v-row no-gutters>
          <v-col cols="6" v-if="$vuetify.breakpoint.smAndDown" class="pr-3 mt-6 mb-n3">
            <v-select
                v-model="pagination.filters.order_type"
                label="Тип пропуска"
                style="padding-bottom: 2px"
                clearable
                dense
                outlined
                :disabled="isLoading"
                :items="choices.order_type"
                hide-details
                single-line
            >
            </v-select>
          </v-col>
          <v-col cols="6" v-if="$vuetify.breakpoint.smAndDown" class="mt-6 mb-n3">
            <v-select
                v-model="pagination.filters.order_status"
                label="Статус заявки"
                style="padding-bottom: 2px"
                clearable
                dense
                outlined
                :disabled="isLoading"
                :items="choices.order_status"
                hide-details
                single-line
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="mt-md-6 mb-n3 mb-md-0 mt-5 pr-md-3">
            <v-text-field
                dense
                outlined
                v-model="pagination.filters.start_date" type="date"
                label="Дата начала действия пропуска" clearable :disabled="isLoading">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="mt-md-6">
            <v-text-field
                outlined
                dense
                v-model="pagination.filters.end_date" type="date"
                label="Дата окончания действия пропуска" clearable :disabled="isLoading">
            </v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-slide-y-transition>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        multi-sort
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.through_number="props">
        <span v-if="props.item.through_number === null" style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">Отсутствует</span>
        <span v-else style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">{{props.item.through_number}}</span>
      </template>
      <template v-slot:item.order_type="{ item }">
        <span>
          <v-icon
              class="mr-2"
          >
            {{ orderTypeIcons(item) }}
          </v-icon>
          {{ item.order_type }}
        </span>
      </template>
      <template v-slot:item.status="{ item }">
        <span>{{ order_status(item) }}
          <v-tooltip bottom  v-if="item.automate_annul">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                small
                class="pb-1 medium-primary"
                v-bind="attrs"
                v-on="on"
            >
              hdr_auto
            </v-icon>
          </template>
          <span>Аннулирована автоматически</span>
          </v-tooltip>
        </span>
      </template>
      <template v-slot:item.organization="{ item }">
        <span>{{ item.organization.abbr }}</span>
      </template>
      <template v-slot:item.territory="{ item }">
        <span>{{ item.territory.name }}</span>
      </template>
      <template v-slot:item.designer="{ item }">
        <span v-if="!!item.main_designer">{{ item.main_designer.fio }}</span>
        <span v-else>{{ item.designer.fio }}</span>
      </template>
      <template v-slot:item.last_update="{ item }">
        <span>{{ displayDate(item.last_update, true) }}</span>
      </template>
      <template v-slot:item.start_date="{ item }">
        <span>{{ displayDate(item.start_date) }}</span>
      </template>
      <template v-slot:item.end_date="{ item }">
        <span>{{ displayDate(item.end_date) }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="getLog(item)"
                v-bind="attrs"
                v-on="on"
            >
              assignment
            </v-icon>
          </template>
          <span>Журнал логирования</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="editOrder(item)"
                v-bind="attrs"
                v-on="on"
            >
              edit
            </v-icon>
          </template>
          <span>Редактировать заявку</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="deleteOrder(item)"
                v-bind="attrs"
                v-on="on"
                class="mr-2"
            >
              delete
            </v-icon>
          </template>
          <span>Удалить заявку</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="updateData"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
    <OrdersDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :order-data="order_data"
        @close="closeEditDialog"
    ></OrdersDialog>
    <download-file-dialog
        v-if="dialog_download"
        :opened="dialog_download"
        :choices="choices"
        :unloading-from="unloadingFile"
        @close="closeDownloadDialog"
    ></download-file-dialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить данную заявку ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import OrdersDialog from "../components/OrdersEditDialog";
import DownloadFileDialog from "@/modules/admin/orders/components/DownloadFileDialog.vue";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import names from "@/modules/admin/routers/names";
import {displayDate} from "@/helper";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";

export default {
  name: "AdminOrdersList",
  components: {OrdersDialog, ApplyDialog, DownloadFileDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список заявок",
      show: false,
      dialog_add_edit: false,
      dialog_delete: false,
      dialog_download: false,
      order_data: undefined,
      edit_status: undefined,
      search: {
        parameter: "search"
      },
      pagination: {
        filters: {
          "order_type": null,
          "order_status": null,
          "start_date": null,
          "end_date": null
        }
      },
      choices: {
        order_type: [],
        order_status: [],
        order: [{value: "orders", text: "Все заявки"}, {value: "overdue_departures", text: "Просроченный выезд автомобилей"}]
      },
      headers: [
        {text: "Номер", value: "through_number", sortable: true, align: "start" , width: "7%"},
        {text: "Тип пропуска", value: "order_type", sortable: false, align: "start" , width: "10%"},
        {text: "Заявитель", value: "designer", sortable: false, align: "start", width: "10%"},
        {text: "Организация", value: "organization", sortable: false, align: "start", width: "5%"},
        {text: "Территория", value: "territory", sortable: false, align: "start", width: "10%"},
        {text: "Дата начала", value: "start_date", sortable: true, align: "center", width: "8%"},
        {text: "Дата окончания", value: "end_date", sortable: true, align: "center", width: "7%"},
        {text: "Статус", value: "status", sortable: false, align: "center", width: "7%"},
        {text: "Изменение статуса", value: "last_update", sortable: true, align: "center", width: "7%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "10%"}
      ]
    }
  },
  watch: {
  },
  computed:{
    ...mapGetters({
      items: "admin/getOrdersList",
      count: "admin/getOrdersCount",
      isLoading: "admin/isLoadingOrders",
      getCurrentUrl: "admin/getOrdersCurrentUrl"
    }),
    extensionHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 170
      } else {
        return 0
      }
    }
  },
  methods: {
    ...mapActions({
      loadOrdersList: "admin/loadOrdersList",
      deleteOrders: "admin/deleteOrders",
      unloadingFile: "admin/unloadingFile",
      loadOrderTypeChoices: "choices/loadOrderTypeChoices",
      loadOrderStatusChoices: "choices/loadOrderStatusChoices"
    }),
    displayDate: displayDate,
    generateFile(){
      this.dialog_download = true
    },
    getDetail(item) {
      this.$router.push({name: names.ORDERS.DETAIL, params: {idOrders: item.id}}).catch(() => {})
    },
    getLog(item) {
      this.$router.push({name: names.ORDERS.LOG, params: {idOrders: item.id}}).catch(() => {})
    },
    updateData(){
      if (this.search.value) {
        this.search.value = ""
        this.loadData()
      }
      this.pagination.filters = {
          "order_type": null,
          "order_status": null
      }
    },
    loadData(url=undefined){
      this.loadOrdersList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          if (this.pagination.filters.order_type)
            new_url = this.addGetParameter(new_url, "order_type", this.pagination.filters.order_type)
          if (this.pagination.filters.order_status)
            new_url = this.addGetParameter(new_url, "order_status", this.pagination.filters.order_status)
          // new_url = this.addGetParameter(new_url, "start_date", new Date().toISOString().split("T")[0])
          return new_url
        },
        finalizer: (data, url) => {
          // if (url.toString().includes("start_date")) {
          //   this.pagination.filters.start_date = new Date().toISOString().split("T")[0]
          // }
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newOrder() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.order_data = undefined
    },
    editOrder(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.order_data = item
    },
    deleteOrder(item) {
      this.dialog_delete = true
      this.order_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.order_data = undefined
    },
    closeDownloadDialog(event) {
      this.loadData()
      this.dialog_download = false
    },
    closeDeleteDialog(event) {
      if(event){
        this.deleteOrders({
          id: this.order_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.order_data = undefined
    },
    order_status (item) {
      if (item.is_formalized && item.is_agreed === null && !item.automate_annul) {
        return "Оформлена"
      } else if (item.is_withdrawn) {
        return "Отозвана"
      } else if (item.is_agreed && item.is_formalized && !item.is_annul) {
        return "Согласована"
      } else if (item.is_agreed === false && item.is_formalized) {
        return "Отклонена"
      } else if (item.is_agreed === true && item.is_annul || item.automate_annul) {
        return "Аннулирована"
      } else {
        return "Создана"
      }
    },
    orderTypeIcons (item) {
      if (String(item.order_type) === "Разовый") {
        return "today"
      } else if (String(item.order_type) === "Временный") {
        return "calendar_month"
      } else if (String(item.order_type) === "Массовый") {
        return "groups"
      } else if (String(item.order_type) === "Автомобильный разовый") {
        return "directions_bus"
      } else if (String(item.order_type) === "Автомобильный временный") {
        return "departure_board"
      } else {
        return "confirmation_number"
      }
    },
    loadChoices() {
      this.loadOrderTypeChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_type = val
        }
      })
      this.loadOrderStatusChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_status = val
        }
      })
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
      this.loadChoices()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }

}

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
